class GiftingContentTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("mouseenter", () => this._fetchTemplateContent());
    this.addEventListener("focus", () => this._fetchTemplateContent());
    this.addEventListener("click", () => this._trigger());
  }

  disconnectedCallback() {}

  get cartUrl() {
    return window.routes.cart_url;
  }

  get templateName() {
    return this.getAttribute("gifting-template");
  }

  _fetchTemplateContent() {
    if (this._data) return Promise.resolve(this._data.cloneNode(true));
    if (this._loading) return this._loading;

    this._loading = fetch(this.cartUrl)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const template = doc.querySelector(
          `[data-gifting-template="${this.templateName}"]`,
        );
        this._data = template
          ? template.content
          : document.createDocumentFragment();
        return this._data.cloneNode(true);
      });

    return this._loading;
  }

  _trigger() {
    this.querySelector("button").dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: {
          target: this.templateName,
          html: this._fetchTemplateContent(),
        },
      }),
    );
  }
}

if (!customElements.get("gifting-content-trigger")) {
  customElements.define("gifting-content-trigger", GiftingContentTrigger);
}
